import PropTypes from "prop-types";
import React from "react";

import FormButton from "../form/FormButton";
import ModalFooter from "../modal/ModalFooter";
import ModalFooterLeftGroup from "../modal/ModalFooterLeftGroup";
import ModalFooterRightGroup from "../modal/ModalFooterRightGroup";

const WelcomeWizardFooter = props => {
  return (
    <ModalFooter>
      {props.showBack ? (
        <ModalFooterLeftGroup>
          <FormButton primary={false} label={props.backText ? props.backText : "Back"} onClick={props.onBackClick} />
        </ModalFooterLeftGroup>
      ) : null}
      <ModalFooterRightGroup>
        {props.showError ? <div className="settingsErrorMessage">{props.errorMessage}</div> : null}
        {props.showNext ? (
          <FormButton
            primary={!props.showDone}
            label={props.nextText ? props.nextText : "Next"}
            onClick={props.onNextClick}
            disabled={props.disableNext}
          />
        ) : null}
        {props.showDone ? (
          <FormButton
            primary={true}
            label={props.doneText ? props.doneText : "OK"}
            onClick={props.onDoneClick}
            disabled={props.disableDone}
          />
        ) : null}
      </ModalFooterRightGroup>
    </ModalFooter>
  );
};

WelcomeWizardFooter.propTypes = {
  showBack: PropTypes.bool,
  showNext: PropTypes.bool,
  showDone: PropTypes.bool,
  backText: PropTypes.string,
  nextText: PropTypes.string,
  doneText: PropTypes.string,
  onBackClick: PropTypes.func,
  onNextClick: PropTypes.func,
  onDoneClick: PropTypes.func,
  disableNext: PropTypes.bool,
  disableDone: PropTypes.bool,
  showError: PropTypes.bool,
  errorMessage: PropTypes.string
};

export default WelcomeWizardFooter;
